import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Button } from 'primeng/button';
import { Card } from 'primeng/card';
import { ChartModule } from 'primeng/chart';
import { Select } from 'primeng/select';
import { DatePickerModule } from 'primeng/datepicker';
import { ScriptableContext } from 'chart.js';

@Component({
  selector: 'app-analysis-component',
  imports: [FormsModule, Card, Select, ChartModule, Button, DatePickerModule],
  templateUrl: './analysis-component.html',
  styleUrl: './analysis-component.scss'
})
export class AnalysisComponent {

  dateOptions = [{ label: 'Today', value: 'today' }];
  weekOptions = [{ label: 'Weekly', value: 'weekly' }];
  yearOptions = [{ label: '2023', value: 2023 }];

  selectedDate = 'today';
  selectedWeek = 'weekly';
  selectedYear = 2023;

  topStats = [
    { label: 'Total Rides', value: 935, icon: 'pi pi-car' },
    { label: 'Unique Rides', value: 200, icon: 'pi pi-users' },
    { label: 'Total Distance', value: '40804.26', icon: 'pi pi-map' },
    { label: 'Rides Cost', value: 'AED70,959.08', icon: 'pi pi-map' },
    { label: 'Total Duration', value: '155.01', icon: 'pi pi-map' }
  ];

  midStats = [
    { label: 'Avg ride distance (km)', value: 200 },
    { label: 'Avg ride duration (min)', value: 200 },
    { label: 'Avg ride price', value: 200 },
    { label: 'Avg rating', value: 200 }
  ];

  bottomStats = [
    { label: 'Tasks created', value: 200 },
    { label: 'Tasks done', value: 200 },
    { label: 'Damage reports created', value: 200 },
    { label: 'Damage reports approved', value: 200 },
    { label: 'Damage reports done', value: 200 }
  ];

  reservationData = {
    labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
    datasets: [
      {
        data: [30, 12, 25, 35, 18, 28, 8],
        backgroundColor: '#2A67B1',
        borderRadius: 8,
        borderSkipped: false,
        maxBarThickness: 24
      }
    ],
  };

  carData = {
    labels: ['Sport Car', 'SUV', 'Coupe', 'Hatchback', 'MPV'],
    datasets: [{
      data: [17489, 9478, 18197, 12510, 14006],
      backgroundColor: ['#0D3559', '#175D9C', '#2185DE', '#63A9E8', '#A6CEF2'],
      borderWidth: 10
    }]
  };

  carList = [
    { label: 'Sport Car', value: 17489, color: '#0B3C5D' },
    { label: 'SUV', value: 9478, color: '#1F7AE0' },
    { label: 'Coupe', value: 18197, color: '#4FA3F7' },
    { label: 'Hatchback', value: 12510, color: '#9CCBFF' },
    { label: 'MPV', value: 14006, color: '#CFE6FF' }
  ];

  kpiData = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    datasets: [
      {
        data: [55, 30, 20, 60, 45, 30, 80, 90, 45, 75, 25, 40],
        backgroundColor: (ctx: ScriptableContext<'bar'>) => {
          const chart = ctx.chart;
          const { ctx: canvasCtx, chartArea } = chart;

          if (!chartArea) return;

          const gradient = canvasCtx.createLinearGradient(
            0,
            chartArea.bottom,
            0,
            chartArea.top
          );

          gradient.addColorStop(0, 'rgba(151, 187, 232, 0.08)');
          gradient.addColorStop(1, 'rgba(151, 187, 232, 0.40)');

          return gradient;
        },
        borderRadius: { topLeft: 12, topRight: 12 },
        borderSkipped: false,
        barPercentage: 0.55,
        categoryPercentage: 0.6
      }
    ]
  };

  barOptions = {
    responsive: true,
    maintainAspectRatio: false,
    aspectRatio: true,
    plugins: {
      legend: { display: false },
      tooltip: {
        enabled: true,
        backgroundColor: '#2A67B1',
        titleColor: '#fff',
        bodyColor: '#fff'
      }
    },
    scales: {
      x: {
        grid: { display: false, drawBorder: false },
        ticks: {
          color: '#878787'
        }
      },
      y: {
        min: 0,
        max: 40,
        ticks: {
          stepSize: 10,
          color: '#878787'
        },
        grid: {
          color: 'rgba(100, 100, 100, 0.2)',
          borderDash: [5, 5],
          drawTicks: false,
          drawBorder: false,
        }
      },
    },
  };

  donutOptions = {
    cutout: '75%',
    responsive: true,
    maintainAspectRatio: false,
    aspectRatio: true,

    plugins: {
      legend: { display: false },
      tooltip: {
        enabled: true,
        backgroundColor: '#2A67B1',
        titleColor: '#fff',
        bodyColor: '#fff'
      },
    },
  };

  kpiBarOptions = {
    responsive: true,
    maintainAspectRatio: false,
    aspectRatio: true,
    plugins: {
      legend: { display: false },
      tooltip: {
        enabled: true,
        backgroundColor: '#2A67B1',
        titleColor: '#fff',
        bodyColor: '#fff'
      }
    },
    scales: {
      x: {
        grid: { display: false, drawBorder: false },
      },
      y: {
        min: 0,
        max: 100,
        ticks: {
          stepSize: 20,
          callback: (v: number) => v + '%'
        },
      },
    },
  };
}
